import { Route, Routes } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import { ProSidebarProvider } from "react-pro-sidebar";
import BlankLayout from "../layouts/BlankLayout";
import { map } from "lodash";

import otherRoutes from "./other.routes.config";
import ProtectedRouteWrapper from "./ProtectedRouteWrapper";
import { privateRoutes } from "./private.route.component.config";

const AdminRoutes = () => {
    return (
        <ProSidebarProvider >
            <Routes>
                <Route element={<ProtectedRouteWrapper permissions={["ADMIN", "VIEWER", "OPERATION_USER", "INQ_MANAGER"]}><AdminLayout /></ProtectedRouteWrapper>}>
                    {
                        privateRoutes && map(privateRoutes, (value, key) => (
                            <Route path={value.path} element={<ProtectedRouteWrapper permissions={value.permission}>
                                {value.element}
                            </ProtectedRouteWrapper>} key={key} />
                        ))
                    }
                </Route>

                {/* 404 for frontend */}
                <Route element={<BlankLayout />}>
                    {
                        otherRoutes && map(otherRoutes, (val, k) => (
                            <Route path={val.path} element={val.element} key={k} />
                        ))
                    }
                </Route>

            </Routes>
        </ProSidebarProvider>

    )
}

export default AdminRoutes;